import { useValidate } from "formvalidation/hooks";
import React, { useEffect } from "react";
import { Input } from "semantic-ui-react";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { saveOrCancel } from "utilities/inputUtils";

interface Props {
  value: string
  onValueChange: (newValue: string) => void
  validatorKey: string
  focusOnMount?: boolean
  onEnter?: () => void
  onEsc?: () => void
  maxLength: number
}

const UrlInput = (props: Props) => {
  const semanticRef = useSemanticUiInputRef();

  useEffect(() => {
    if (props.focusOnMount) {
      semanticRef.ref.current.focus();
    }
  }, []);

  const verifyIsValid = async () => {
    if (props.value == null || props.value === "") {
      return true;
    }

    const result = await window.CoreApi.Url.Reformat(props.value)
    const isValid = !result.data.hasErrors;

    return isValid;
  };

  const validation = useValidate({
    key: props.validatorKey,
    title: "URL",
    value: props.value,
    validate: verifyIsValid,
    ref: semanticRef.ref,
    type: "manual"
  })

  return <Input
    ref={semanticRef.refSetter}
    onKeyDown={e => saveOrCancel(e, { onEnter: props.onEnter, onEsc: props.onEsc, validation, value: props.value })}
    fluid
    error={validation.error.hasError}
    value={props.value}
    onChange={(_, { value }) => { props.onValueChange(value); }}
    onBlur={validation.validateAndSetError}
    maxLength={props.maxLength}
  />;
};

export default UrlInput;
